import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { useMemo } from "react";
import { mapDefectEstimatedCosts } from "../../utils/defectTableHelper";

export const EstimatedCostFilter = (options: ColumnFilterElementTemplateOptions) => {
    const estimateCostOptions = useMemo(() => (
        mapDefectEstimatedCosts()
    ), []);

    return (
    <MultiSelect
        data-cy="defect-estimate-cost-filter-input"
        value={options.value}
        options={estimateCostOptions}
        onChange={(e: MultiSelectChangeEvent) => options.filterApplyCallback(e.value)}
        placeholder="Show all"
        className="p-column-filter"
        maxSelectedLabels={0}
        showClear
        scrollHeight="400px"
    />
    );
};